/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
});

class ReportFinopsSelector extends React.Component {
  state = {
    sectionType: "",
    open: false,
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes } = this.props;

    return (
      <form autoComplete="off">
        <Button
          className={classes.button}
          onClick={this.handleOpen}
          style={{
            fontWeight: "bold",
            boxShadow: "none"
          }}
        >
          Finops Modele : {this.state.sectionType}
        </Button>  
        <FormControl className={classes.formControl}
          style={{
            border: "none",
            height: "0px",
            visibility: "hidden"
          }}
        >
          <InputLabel htmlFor="section-open-select">Select Theme</InputLabel>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.sectionType}
            onChange={this.handleChange}
            inputProps={{
              name: 'sectionType',
              id: 'section-open-select',
            }}
          >
            <MenuItem value={"Simple Modele"}>Simple Modele</MenuItem>
            <MenuItem value={"Graphics Modele"}>Graphics Modele </MenuItem>
            <MenuItem value={"Modele X"}>Modele X</MenuItem>
          </Select>
        </FormControl>
      </form>

    );
  }
}

ReportFinopsSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ReportFinopsSelector);